import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';
import { QUERY_KEYS } from '@shared/constants';

export const useTwoFactorStatus = () => {
  return useQuery({
    queryKey: QUERY_KEYS.twoFactorStatus,
    queryFn: () => container.twoFactor.status(),
  });
};

export const useEnableTwoFactor = () => {
  return useMutation({
    mutationFn: () => container.twoFactor.enable(),
  });
};

export const useConfirmTwoFactor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (code: string) => container.twoFactor.confirm(code),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.twoFactorStatus });
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.currentUser });
    },
  });
};

export const useDisableTwoFactor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (password: string) => container.twoFactor.disable(password),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.twoFactorStatus });
      queryClient.invalidateQueries({ queryKey: QUERY_KEYS.currentUser });
    },
  });
};

export const useRegenerateRecoveryCodes = () => {
  return useMutation({
    mutationFn: () => container.twoFactor.regenerateRecoveryCodes(),
  });
};
